// src/layouts/legal/Eula.js
import React from "react";
import { Container, Typography } from "@mui/material";

export default function Eula() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" gutterBottom>
        End-User License Agreement (EULA)
      </Typography>
      <Typography paragraph>
        This EULA grants you a limited, non-exclusive, non-transferable license to use the Service
        subject to these terms.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Usage Restrictions
      </Typography>
      <Typography paragraph>
        No reverse engineering, decompiling, or reselling. No use that violates law or third-party
        rights.
      </Typography>

      <Typography variant="h5" gutterBottom>
        Updates & Availability
      </Typography>
      <Typography paragraph>
        We may update the Service. No guarantee of uninterrupted availability.
      </Typography>
    </Container>
  );
}
